import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center mb-6" }
const _hoisted_2 = { class: "w-12 h-12 rounded-full mx-auto bg-green-100 flex justify-center items-center flex-shrink-0" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "w-full mt-3" }
const _hoisted_5 = { class: "text-sm leading-5 text-gray-500" }
const _hoisted_6 = { class: "mt-6 flex space-x-2 justify-between" }

import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/solid'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeInModal',
  props: {
    show: {
        type: Boolean
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    customClass: {
        type: String,
        default: 'w-[480px] p-6 patientLogs-modal'
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: __props.customClass,
    show: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(QuestionMarkCircleIcon), { class: "w-6 h-6 text-green-600 mx-auto" })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "fields")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.content), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (__props.cancelText)
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 0,
              size: "large",
              btnWidth: "quinary rounded-lg w-full",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.cancelText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.actionText)
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 1,
              size: "large",
              btnWidth: "rounded-lg w-full bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.actionText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["customClass", "show"]))
}
}

})